import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb6013f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my_publish" }
const _hoisted_2 = { class: "list flex-1" }
const _hoisted_3 = { class: "list-item flex-row" }
const _hoisted_4 = { class: "info-ctn flex-column" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "time" }
const _hoisted_8 = ["innerHTML"]

import { ref, onMounted } from "vue"
import router from "@/router"
import { useRoute } from "vue-router"
import { ycNoticeApi } from "@/api/my" // 接口
import { showNotify, showLoadingToast, closeToast } from "vant"

export default /*#__PURE__*/_defineComponent({
  __name: 'systemNoticeDetail',
  setup(__props) {

const datas = ref({})
const route = useRoute()
onMounted(() => {
  if (route.query.id) {
    getDataDetail(route.query.id)
  }
})
// 获取详情
const getDataDetail = (id: any) => {
  showLoadingToast({
    message: "加载中"
  })
  ycNoticeApi(id).then((res: any) => {
    closeToast()
    if (res.code == 200) {
      closeToast()
      datas.value = res.data
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(datas.value.noticeTitle || "--"), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(datas.value.createTime || "--"), 1),
            _createElementVNode("p", {
              class: "del",
              innerHTML: datas.value.noticeContent
            }, null, 8, _hoisted_8)
          ])
        ])
      ])
    ])
  ]))
}
}

})